import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
type Material = {
  n: string;
  color: 'rose' | 'gold';
  title: string;
  tagline: string;
  meta: string;
  image: string;
  highlights: string[];
  closing: string;
};
const materials: Material[] = [{
  n: '01',
  color: 'rose',
  title: 'Mindfulness — Kit Antiestrés para el Trabajo',
  tagline: 'Recuperá la calma sin tener que desaparecer media hora de tu jornada.',
  meta: '20 páginas prácticas',
  image: 'https://cdn.magicpatterns.com/uploads/dWUrz8hADYcW3vAonmjRWX/MINDFULNESS_—_KIT_ANTIESTRES_PARA_EL_TRABAJO.png',
  highlights: ['Ejercicios de respiración.', 'Pausas de 60 segundos.', 'Grounding para volver al presente.', 'Técnicas para recuperar el foco.', 'Qué hacer después de un conflicto.', 'Cómo bajar la activación antes de responder.', 'Cómo cerrar mentalmente la jornada.', 'Transición del trabajo a casa.'],
  closing: 'Ideal para esos momentos en los que sentís que tu cabeza va más rápido que vos.'
}, {
  n: '02',
  color: 'gold',
  title: 'Kit Práctico de Conversaciones Difíciles',
  tagline: 'Hay conversaciones que no podés seguir evitando.',
  meta: '20 páginas prácticas',
  image: 'https://cdn.magicpatterns.com/uploads/nBfwdNWyQhUYbXjFn5tS3r/KIT_PRACTICO_DE_CONVERSACIONES_DIFICILES.png',
  highlights: ['Qué hacer cuando te hablan mal.', 'Cómo poner un límite.', 'Qué hacer cuando insisten.', 'Cómo responder críticas injustas.', 'Pasivo-agresividad.', 'Decir NO.', 'Sobrecarga laboral.', 'Hablar con un jefe difícil.', 'Manipulación y culpa.', 'Presión.', 'Cómo frenar una conversación que se descontrola.'],
  closing: 'Aprendé a afrontar el problema sin convertir la conversación en otro problema.'
}, {
  n: '03',
  color: 'rose',
  title: '100 Respuestas para Situaciones Difíciles',
  tagline: 'Para cuando sabés lo que pensás… pero no encontrás las palabras.',
  meta: '100 frases concretas organizadas por situaciones laborales reales',
  image: 'https://cdn.magicpatterns.com/uploads/dTLDJpkxu8NYALs1Bn6ZCS/100_RESPUESTAS_PARA_SITUACIONES_DIFICILES.png',
  highlights: ['Cuando te hablan mal.', 'Cuando necesitás decir NO.', 'Cuando quieren cargarte más trabajo.', 'Cuando te critican.', 'Cuando te interrumpen.', 'Cuando aparecen chismes o provocaciones.', 'Cuando intentan manipularte.', 'Cuando tenés que hablar con tu jefe.', 'Cuando la conversación ya está difícil.'],
  closing: 'Abrí la situación que necesitás y encontrá una forma clara de responder.'
}, {
  n: '04',
  color: 'gold',
  title: 'Ejercicios Prácticos para Mejorar el Ambiente Laboral',
  tagline: 'Porque no todo consiste en soportar mejor el trabajo. También podemos trabajar mejor.',
  meta: '10 ejercicios aplicables individualmente o en equipo',
  image: 'https://cdn.magicpatterns.com/uploads/94SmgWww5S6R4w34NHGMk2/EJERCICIOS_PRACTICOS_PARA_MEJORAR_EL_AMBIENTE_LABORAL.png',
  highlights: ['Detectar qué ayuda y qué desgasta.', 'Cambiar quejas por pedidos.', 'Crear acuerdos claros.', 'Escuchar sin preparar la respuesta.', 'Resolver problemas sin buscar culpables.', 'Reconocer lo que funciona.', 'Reducir fricciones en reuniones.', 'Hablar de pequeños problemas antes de que crezcan.', 'Crear acuerdos de trabajo.'],
  closing: 'Pequeños cambios en la forma de trabajar pueden cambiar muchísimo la experiencia cotidiana.'
}];
export function ModulesSection() {
  return <section className="w-full bg-bg-warm py-20 md:py-28 px-4" data-id="element-150" data-mp="tjxgh6mvheym">
      <div className="max-w-6xl mx-auto" data-id="element-151" data-mp="2qg4ndyi5yhq8">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-152" data-mp="2vdog23flyx1p">
          <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-4 py-1.5 rounded-full mb-5" data-id="element-153" data-mp="2a0cn3qo9vp0w">
            <span className="text-xs font-bold tracking-widest" data-id="element-154" data-mp="253cjrnit50dh">
              📦 CONTENIDO COMPLETO
            </span>
          </div>
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-155" data-mp="1cdxb34em7jkq">
            Todo lo que{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-156" data-mp="1r4cucdnh0hg9">
              recibís
            </span>
          </h2>
          <p className="font-serif-italic text-rose text-lg md:text-xl mt-3" data-id="element-157" data-mp="yminek9riu7c">
            4 materiales completos + 2 materiales premium · +60 páginas
            prácticas
          </p>
        </motion.div>

        <div className="space-y-8" data-id="element-158" data-mp="35b16zzyplbca">
          {materials.map((m, i) => <motion.article key={m.n} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white border border-line rounded-3xl p-6 md:p-9 shadow-sm hover:shadow-lg transition-shadow" data-id="element-159" data-mp="358y6glzxjztb" data-mpi={i}>
              {/* Header: mockup + title side by side */}
              <div className="flex flex-col sm:flex-row items-center sm:items-end gap-6 md:gap-8 mb-6" data-id="element-160" data-mp="3f0az3ftjyu0e">
                <img src={m.image} alt={m.title} className="w-40 sm:w-44 md:w-52 h-auto flex-shrink-0 drop-shadow-xl" data-id="element-161" data-mp="3j0ctd3wykl5n" />
                <div className="text-center sm:text-left" data-id="element-162" data-mp="27obxl51ofwge">
                  <div className={`text-[11px] font-bold tracking-widest mb-2 ${m.color === 'rose' ? 'text-rose' : 'text-gold'}`} data-id="element-163" data-mp="e4jq56smeyex">
                    MATERIAL {m.n}
                  </div>
                  <h3 className="font-serif font-bold text-2xl md:text-3xl text-ink uppercase leading-tight" data-id="element-164" data-mp="4cw45leu29ku">
                    {m.title}
                  </h3>
                  <p className="text-ink-soft text-base leading-relaxed mt-3" data-id="element-165" data-mp="3rjpti6dtpgyk">
                    {m.tagline}
                  </p>
                  <div className="inline-flex items-center gap-2 bg-rose-bg text-rose text-xs font-bold px-3 py-1.5 rounded-full mt-4" data-id="element-166" data-mp="3mjadf725pvcw">
                    {m.meta}
                  </div>
                </div>
              </div>

              <ul className="border-t border-line pt-6 grid sm:grid-cols-2 gap-x-8 gap-y-2.5" data-id="element-167" data-mp="3coa62k7r0jb5">
                {m.highlights.map((h, j) => <li key={j} className="flex items-start gap-2.5" data-id="element-168" data-mp="1auax45i3me1m" data-mpi={j}>
                    <span className={`flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center mt-0.5 ${m.color === 'rose' ? 'bg-rose/15' : 'bg-gold/15'}`} data-id="element-169" data-mp="1jbjj7x7cougj">
                      <CheckIcon className={`w-3 h-3 ${m.color === 'rose' ? 'text-rose' : 'text-gold'}`} strokeWidth={3} data-id="element-170" data-mp="1s44y327v2h03" />
                    </span>
                    <span className="text-ink text-sm" data-id="element-171" data-mp="10dgyhulu5joj">{h}</span>
                  </li>)}
              </ul>

              <p className="font-serif-italic text-rose text-base md:text-lg mt-6" data-id="element-172" data-mp="14estkfnhax44">
                {m.closing}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}